export default __webpack_public_path__ + "static/media/h7.75408285.PNG";